<template>
  <div class="goodsinfo">
    <img class="caseInfo_head" src="static/menhu/images/case1.webp" />

    <!-- 成功案例 -->
    <div class="simple-recent-projects carousel-projects">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="section-heading">
              <h2>公司成功案例</h2>
              <p>西安案例展览与分享.</p>
            </div>
          </div>
          <div class="col-lg-6">
            <div style="cursor: pointer" class="main-dark-button" @click.prevent="$router.push('caseIList')">
              <a >查看更多案例</a>
            </div>
          </div>

          <div class="scroll-container">
            <div class="scroll-content">
              <div class="item" v-for="(item,index) in caseList" :key="index">
                <p class="item_title">{{ item.name }}</p>
                <el-image
                  style="width: 100%;height: 100%;"
                  :src="$fileDPath+(item.imgs.split(',')[0])"
                  fit="cover"
                  @click="doCaseClick(item.id)"
                >

                </el-image>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="caseInfo_title" >
      <p>部分合作伙伴</p>
    </div>
    <div class="caseInfo_comps">
      <el-carousel indicator-position="outside" :interval="1800" height="700px">
        <el-carousel-item v-for="item in 16" :key="item">
          <el-image
            style="width: 100%;height: 100%"
            :src="'/static/anli/a'+(item)+'.png'"
            fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>



    <caseDesc v-if="isShow" :id="nowID" :isShow="isShow" @close="isShow=false;nowID=null" />


  </div>
</template>

<script>
import caseDesc from '@/components/views/compCase/caseDesc.vue';
export default {
  name: 'goodsinfo',
  components:{caseDesc},
  data() {
    return {
      caseList:[],
      isShow:false,
      nowID:null
    }
  },
  created() {
    console.dir(this.$);
    this.getData();
  },
  methods:{
    getData(){
      let _this = this;
      this.$axios.get('/fantis/cases/ftCmsCases/list?pageNo=1&pageSize=6')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            _this.caseList = tempData.records;
          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 点击图片
    doCaseClick(id){
      this.nowID = id;
      this.isShow = true;
    }
  }
}
</script>

<style scoped>
.caseInfo_title{
  text-align: center;
}
.caseInfo_title p{
  color: #333;
  font-size: 36px;
}
.caseInfo_comps{
  width: 100%;
  box-sizing: border-box;
  height: 710px;
  padding: 2% 10%;
}

.text-button p{
  color: white;
}

.scroll-container {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  background-color: #f0f0f0;
}

.scroll-content {
  display: inline-block;
  animation: scroll 25s linear infinite;
}

.item {
  display: inline-block;
  width: 350px;
  height: 230px;
  background-color: #2c2c2c;
  color: white;
  border-radius: 5px;
  font-size: 1.5rem;
  margin-left: 20px;
  box-sizing: border-box;
  padding: 10px;
  position: relative
}

.item_title{
  position: absolute;
  bottom: -15px;
  z-index: 99;
  font-size: 18px;
  font-weight: bolder;
  background-color: rgba(54, 53, 53, 0.5);
  color: white;
  width: 94%;
  padding: 10px 20px;
}

.scroll-content:hover {
  animation-play-state: paused; /* 暂停动画 */
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-40%);
  }
  100% {
    transform: translateX(1%);
  }
}

@media only screen and (max-width: 800px) {
  /deep/ .el-carousel__container{
    height: 170px !important;
  }

  .caseInfo_comps{
    height: 180px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/compCase/caseIndex.vue